import { Text, Heading, Stack } from "@sembark-travel/ui/base"
import { Spinner } from "@sembark-travel/ui/base"
import { useXHR } from "@sembark-travel/xhr"
import useSWR from "swr"
import { IUser } from "../Users"
import { IQuoteFlight, ITrip, transformFlightsDetailsToPreview } from "./store"
import { QuoteFlights } from "./Quotes"

interface IFlightBooking extends IQuoteFlight {
	guest_name: string
	pnr?: string
	booked_price: number
	booked_at?: string
	booked_by?: IUser
	dropped_at?: string
	dropped_by?: IUser
	drop_reason?: string
}

interface ITripFlightBooking
	extends Pick<
		ITrip,
		| "id"
		| "children"
		| "destinations"
		| "start_date"
		| "start_date_local"
		| "end_date"
		| "end_date_local"
		| "days"
		| "nights"
		| "trip_source"
		| "no_of_adults"
		| "tourist"
		| "reference_id"
		| "operations_team"
	> {
	converted_at: string
	converted_by: IUser
	package_price: number
	flights: Array<IFlightBooking>
	is_shared?: boolean
	can_modify?: boolean
}

type IFlightBookingsProps = { tripId: string | number }

export default function FlightBookings({ tripId }: IFlightBookingsProps) {
	const xhr = useXHR()
	const { data: trip } = useSWR<ITripFlightBooking>(
		tripId ? `/trips/${tripId}/flight-bookings` : null,
		() =>
			xhr.get(`/trip-flight-bookings/${tripId}`).then((resp) => resp.data.data)
	)
	if (!tripId) return null
	if (!trip) return <Spinner alignCenter padding="4" />
	const { flights, is_shared } = trip
	return (
		<Stack gap="4">
			<Heading>Flight Bookings</Heading>
			{!flights.length ? (
				<Text>Flights not provided.</Text>
			) : (
				<QuoteFlights
					flightsDetails={transformFlightsDetailsToPreview(flights)}
					flightPrice={flights}
					hidePrice={is_shared}
				/>
			)}
		</Stack>
	)
}
